import { authHref } from '@/shared/lib/auth-return';
import Link from 'next/link';

export function BackToRegisterLink({
	redirectPath,
}: { redirectPath?: string } = {}) {
	return (
		<div className="mt-2 flex flex-row justify-center gap-1 text-center text-sm text-gray-600">
			Нет аккаунта?
			<Link
				href={authHref('/register', redirectPath)}
				className="text-primary hover:text-primary-darken font-medium"
			>
				Зарегистрироваться
			</Link>
		</div>
	);
}
